import React, { FC } from "react";
import { Typography } from "antd";

export const HomePageTitle: FC = () => {
  const { Title } = Typography;

  return (
    <>
      <header>
        <Title level={3}>VLaunch Support</Title>
      </header>
    </>
  );
};
